// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KRDF","comment":"styles_comment__2eio7"};